import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Parts, Types} from "components";
import Select from "react-select";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class RescheduleFourth extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			users: [],
			regions: [],
			selectedUsers: [],
			selectedUser: null,
			selectedRegions: [],
			selectedRegion: null,
		}
	}

	async componentDidMount() {
		await this.getRegions();
	}

	getRegions = async () => {
		let regionModel = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		regionModel.limit = 100;
		try {
			this.regions = await regionModel.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				//Todo maybe filter by ranking instead
				return a.name.localeCompare(b.name)
			});
			this.regions = this.regions.filter((item) => {
				return item.metro_walk_ranking !== null && item.metro_walk_ranking !== undefined
			})
			this.setState({
				regions: this.regions,
			});
		} catch (error) {
			console.log('error', error)
		}
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		let usersPkeys = this.state.selectedUsers.map((user) => user.value);
		try {
			userModel.filter = {
				'filterRegions': this.state.selectedRegion ? [this.state.selectedRegion.value] : null,
				'bookableOnly': true,
			};
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			//let selected = this.users.filter(item => usersPkeys.includes(item.pkey));what was this for?

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleUsers = async (value) => {
		await this.setState({selectedUser: value, field_engineers: []})
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Fourth Reschedule",
				url: `/dispatch/reschedulefourth`,
				icon: 'laptop',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<div className={'row'}>
					<div className={'col-4'} style={{zIndex: 100}}>
						<Parts.RegionSelectToggle
							parent={this}
							handleRegionsCallback={async () => {
								let selectedRegion = this.state.regions.filter(region => {
									return region.pkey === (this.state.filterRegion)
								})[0];
								await this.setState({
									selectedRegion: {value: selectedRegion.pkey, label: selectedRegion.name},
									selectedUser: null,
									field_engineers: []
								});
								await this.getUsers();
							}}
							multi={false}
							noCycle={false}
						/>
					</div>
					<div className={"col-3"} style={{zIndex: 100}}>
						<Select
							key={this.state.users}
							placeholder={"User Select"}
							isMulti={false}
							isClearable={false}
							value={this.state.selectedUser}
							onChange={this.handleUsers}
							options={this.state.users.map(user => {
								return (
									{value: user.pkey, label: user.name_first + " " + user.name_last})
							})}
						/>
					</div>
					{this.state.selectedUser && <div className={"col-3"} style={{zIndex: 100}}>
						<Button color="info" onClick={async () => {
							this.setState({loading: true, refresh: Math.random()})
							this.setState({loading: false})
						}}>
							Refresh
						</Button>
					</div>}
				</div>
				{this.state.selectedUser && <Objects.HelpDeskRescheduleFourth
					id={this.state.selectedUser.value}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
}

